import { t } from 'i18next';
import { groupBy } from 'lodash-es';
import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

import Icon from '../../assets/Icon';
import { FoodTray, SelectedFoodTrayIndex } from '../../models';
import GastronomColumn from './GastronomColumn';

import './Gastronom.scss';

export const MAX_NUMBER_OF_GASTRONOMS = 16;

interface Props {
  foodTrays: FoodTray[];
  selectedFoodTray?: SelectedFoodTrayIndex;
  setSelectedFoodTray?: (selectedFoodTray: SelectedFoodTrayIndex) => void;
  isLoading?: boolean;
  showOrientation?: boolean;
  isOverview?: boolean;
  isTabbable?: boolean;
  onAddColumn?: (columnIndex: number) => void;
  onDeleteColumn?: (columnIndex: number) => void;
  isAdmin?: boolean;
}

const GastronomGrid: FC<Props> = ({
  foodTrays,
  selectedFoodTray,
  setSelectedFoodTray,
  isLoading,
  isOverview,
  onAddColumn,
  onDeleteColumn,
  isTabbable,
  showOrientation,
  isAdmin,
}) => {
  const columns = groupBy(foodTrays, 'columnIndex');
  const numberOfColumns = Object.keys(columns).length;

  return (
    <div className='gastronom-view'>
      {showOrientation && <span className='gastronom-orientation'>
        <Icon name='Customer' />
        <p>{t('lblCustomerSide')}</p>
      </span>}
      <div className='gastronom-grid' >
        {
          isLoading ? (
            <Skeleton width={1000} height={154} />
          ) : (
            Object.keys(columns).map((index: string) => {
              const columnIndex = parseInt(index);
              return (
                <GastronomColumn
                  key={`gastronom-column-${columnIndex}`}
                  foodTrays={columns[columnIndex]}
                  isOverview={isOverview}
                  selectedFoodTray={selectedFoodTray}
                  setSelectedFoodTray={setSelectedFoodTray}
                  onAddColumnLeft={!!onAddColumn ? () => onAddColumn(columnIndex) : undefined}
                  onAddColumnRight={!!onAddColumn ? () => onAddColumn(columnIndex + 1) : undefined}
                  onDeleteColumn={!!onDeleteColumn ? () => onDeleteColumn(columnIndex) : undefined}
                  disableAddButtons={numberOfColumns >= MAX_NUMBER_OF_GASTRONOMS}
                  disableRemoveButton={numberOfColumns === 1}
                  isTabbable={isTabbable}
                  isAdmin={isAdmin}
                />
              );
            })
          )}
      </div >
      {showOrientation && <span className='gastronom-orientation'>
        <Icon name='Kitchen' />
        <p>{t('lblKitchenSide')}</p>
      </span>}
    </div>
  );
};

export default GastronomGrid;
